export class EnergyConsumption {
	adblue?: number;
	consumption: number;
}
